/* eslint-disable no-param-reassign */
import project from 'project.config'
import { store } from 'index'
import { selectCountry, selectLanguage } from 'store/user'
import { authHeader } from '../helpers/auth'
import { userService } from './userService'

export const apiService = {
  get,
  post,
  postForm,
}

function promiseFn(promise) {
  return new Promise((resolve, reject) => promise.then(resolve, reject))
}

function getQueryData() {
  const state = store.getState()
  const language = selectLanguage(state)
  const country = selectCountry(state)
  const queryData = {
    is_web: true,
    language,
    country_code: country,
  }
  return queryData
}

function get(url, data) {
  url = project.apiBaseUrl + url
  url = new URL(url)
  data = { ...data, ...getQueryData() }

  if (typeof url.searchParams !== 'undefined') {
    Object.keys(data).forEach((key) => url.searchParams.append(key, data[key]))
  } else if (typeof URLSearchParams === 'function') {
    url.search = new URLSearchParams(data)
  } else {
    Object.keys(data).forEach((key) => {
      const newParam = `${key}=${data[key]}`
      url.search += url.search !== '' ? `&${newParam}` : `?${newParam}`
    })
  }
  const requestOptions = {
    method: 'GET',
    headers: {
      ...authHeader(),
      Accept: 'application/json',
    },
  }
  return promiseFn(
    fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => Promise.reject(error))
        }
        return response.json()
      })
      .then(
        (responseJson) => responseJson,
        (error) => {
          if (error.success === false && error.data.status === 401) {
            userService.remove()
            window.location.reload()
          }
          return error
        }
      )
      .catch((err) => {
        if (err.data.status === 401) {
          userService.remove()
          window.location.reload()
        }
        return { success: false, data: [{ message: err.message }] }
      })
  )
}

function post(url, data) {
  const body = JSON.stringify(data)
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body,
  }
  const queryData = getQueryData()
  let params = Object.keys(queryData).map((key) => `${key}=${queryData[key]}`)
  params = params.join('&')
  const apiUrl = `${project.apiBaseUrl + url}?${params}`
  return promiseFn(
    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => Promise.reject(error))
        }
        return response.json()
      })
      .then(
        (responseJson) => responseJson,
        (error) => {
          if (error.success === false && error.data.status === 401) {
            userService.remove()
            window.location.reload()
          }
          return error
        }
      )
      .catch((err) => ({ success: false, data: [{ message: err.message }] }))
  )
}

function postForm(url, formData) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
    },
    body: formData,
  }
  const apiUrl = `${project.apiBaseUrl + url}?${Object.entries(getQueryData())
    .map(([key, value]) => `${key}=${value}`)
    .join('&')}`
  return promiseFn(
    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => Promise.reject(error))
        }
        return response.json()
      })
      .then(
        (responseJson) => responseJson,
        (error) => {
          if (error.success === false && error.data.status === 401) {
            userService.remove()
            window.location.reload()
          }
          return error
        }
      )
      .catch((err) => ({ success: false, data: [{ message: err.message }] }))
  )
}
